export default __webpack_public_path__ + "static/media/news_image02.73c168b3.png";